<template>
  <div>
    <shared-provide-variation
      :variation="variation"
      :fromModule="fromModule"
      :toModule="toModule"
      :account="account"
      @change="emitToParent"
    >
      <!-- Atributos personalizados da variação -->
      <panel title="Atributos personalizados da variação (opcional)" style="margin-top:8px">
        <div slot="header-right">
          <button
            class="btn btn--info"
            :disabled="disabledInputs()"
            @click.prevent="addVarAttrRow"
          >
            Adicionar linha
          </button>
        </div>

        <div class="l-row" v-if="!variation.customAttributes.length">
          <div class="l-col-12@md">
            <small class="form-help">Sem atributos nesta variação. Clique em “Adicionar linha”.</small>
          </div>
        </div>

        <div
          class="l-row attr-row"
          v-for="(attr, idx) in variation.customAttributes"
          :key="`var-${skuSafe}-attr-${idx}`"
        >
          <form-group
            :label="'Chave'"
            :columns="5"
            :error="getError(`customAttributes[${idx}].key`, productId, variation.sku)"
            :required="true"
          >
            <input
              class="form-input"
              type="text"
              :disabled="disabledInputs()"
              v-model.trim="attr.key"
              placeholder="Ex.: Cor secundária"
            />
          </form-group>

          <form-group
            :label="'Valor'"
            :columns="5"
            :error="getError(`customAttributes[${idx}].value`, productId, variation.sku)"
            :required="true"
          >
            <input
              class="form-input"
              type="text"
              :disabled="disabledInputs()"
              v-model.trim="attr.value"
              placeholder="Ex.: Bordô"
            />
          </form-group>

          <div class="l-col-2@md attr-actions">
            <button
              class="btn btn--danger"
              :disabled="disabledInputs()"
              @click.prevent="removeVarAttrRow(idx)"
            >
              Remover
            </button>
          </div>
        </div>
      </panel>
    </shared-provide-variation>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import SharedProvideVariation from '@/components/marketplace/shared/provide/Variation'
import Panel from '@/components/template/Panel'
import FormGroup from '@/components/template/FormGroup'
import { getCharacteristicLabel } from '@/components/marketplace/shared/provide/presetCharacteristics'

export default {
  props: {
    variation: {
      type: Object,
      required: true
    },
    fromModule: {
      type: Object,
      required: true
    },
    toModule: {
      type: Object,
      required: true
    },
    productId: {
      type: [String, Number],
      required: true
    },
    account: {
      type: Object,
      required: false,
      default: null
    }
  },
  computed: {
    ...mapGetters('errors', ['getError']),
    skuSafe () { return this.variation.sku || this.variation.id || 'no-sku' }
  },
  mounted () {
    // garante a estrutura base
    if (!this.variation.attributes || typeof this.variation.attributes !== 'object') {
      this.$set(this.variation, 'attributes', {})
    }
    if (!Array.isArray(this.variation.customAttributes)) {
      this.$set(this.variation, 'customAttributes', [])
    }

    this.variation.customAttributes.forEach(attribute => {
      if (!attribute.value) {
        this.$set(attribute, 'value', getCharacteristicLabel(attribute.key, { gender: this.variation.gender }) || '')
      }
    })
  },
  methods: {
    disabledInputs () {
      return this.variation.status === 'sent' || this.variation.status === 'error'
    },
    emitToParent (value) {
      this.$emit('change', value)
    },
    addVarAttrRow () {
      this.variation.customAttributes.push({ key: '', value: '' })
    },
    removeVarAttrRow (idx) {
      this.variation.customAttributes.splice(idx, 1)
    }
  },
  components: {
    SharedProvideVariation,
    Panel,
    FormGroup
  }
}
</script>

<style lang="sass" scoped>
.attr-row
  align-items: center

.attr-actions
  display: flex
  align-items: flex-start

.attr-actions .btn
  margin-top: 8px
</style>



// WEBPACK FOOTER //
// Variation.vue?3490a436